import { render, staticRenderFns } from "./SingleScreen.vue?vue&type=template&id=9a71a10c&scoped=true"
import script from "./SingleScreen.vue?vue&type=script&lang=js"
export * from "./SingleScreen.vue?vue&type=script&lang=js"
import style0 from "./SingleScreen.vue?vue&type=style&index=0&id=9a71a10c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a71a10c",
  null
  
)

export default component.exports